(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-newsletter-band"]) return;
  try {
    
  if (!customElements.get('mt-newsletter-band')) {
    class MtNewsletterBand extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const success = this.querySelector('[data-mtnb-server-success]');
        if (!success) return;
        try { localStorage.setItem('mtnl_native_confirmed_v2', 'subscribed'); } catch (_) {}
        document.dispatchEvent(new CustomEvent('mtnl:subscribed'));
        if (location.hash === '#' + this.querySelector('form').id) success.focus({ preventScroll: true });
        this.querySelector('[data-mtnb-copy]').addEventListener('click', async () => {
          const status = this.querySelector('[data-mtnb-copy-status]');
          try { await navigator.clipboard.writeText(this.dataset.code); status.textContent = this.dataset.copied; }
          catch (_) { status.textContent = this.dataset.copyError; }
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('mt-newsletter-band', MtNewsletterBand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-newsletter-popup"]) return;
  try {
    
if (!customElements.get('mt-newsletter-popup')) {
  class MtNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.bubble = this.querySelector('.mtnl-bubble');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.key = 'mt_welcome_newsletter_seen_v1';
      this.read = (key, session = false) => { try { return (session ? sessionStorage : localStorage).getItem(key); } catch (_) { return null; } };
      this.write = (key, value, session = false) => { try { (session ? sessionStorage : localStorage).setItem(key, value); } catch (_) {} };
      this.seen = () => this.shown || this.read(this.key) === '1' || this.read(this.key, true) === '1';
      this.remember = () => { this.shown = true; this.write(this.key, '1'); this.write(this.key, '1', true); clearTimeout(this.timer); };
      this.confirmed = this.dataset.subscribed === 'true' || this.read('mtnl_native_confirmed_v2') === 'subscribed';
      this.updateBubble = () => { this.bubble.hidden = this.confirmed || this.dataset.showBubble !== 'true' || this.read('mtnl_tab_off', true) === '1'; };
      const markSubscribed = () => { this.confirmed = true; this.write('mtnl_native_confirmed_v2', 'subscribed'); clearTimeout(this.timer); this.updateBubble(); };
      document.addEventListener('mtnl:subscribed', markSubscribed, { signal });
      document.addEventListener('click', event => {
        const trigger = event.target.closest?.('[data-mtnl-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      }, { signal });
      document.addEventListener('keydown', event => {
        if (!['Enter', ' '].includes(event.key) || !event.target.closest?.('.mtnl-trigger')) return;
        event.preventDefault(); this.open(event.target.closest('.mtnl-trigger'));
      }, { signal });
      this.querySelector('[data-mtnl-dismiss]').addEventListener('click', () => { this.write('mtnl_tab_off', '1', true); this.remember(); this.bubble.hidden = true; }, { signal });
      this.closeButton = this.querySelector('[data-mtnl-close]');
      this.countdown = this.querySelector('.mtnl-countdown');
      this.closeLabel = this.closeButton.getAttribute('aria-label');
      this.closeButton.addEventListener('click', () => this.requestClose(), { signal });
      this.dialog.addEventListener('cancel', event => { if (!this.canClose()) event.preventDefault(); }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.requestClose();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.closeDeadline = 0; this.updateCountdown();
        document.documentElement.classList.remove('mtnl-open');
        if (this.previousFocus?.isConnected && this.previousFocus !== document.body) this.previousFocus.focus({ preventScroll: true });
      }, { signal });
      this.querySelector('[data-mtnl-copy]').addEventListener('click', async () => {
        const status = this.querySelector('[data-mtnl-copy-status]');
        try { await navigator.clipboard.writeText(this.dataset.code); status.textContent = this.dataset.copied; }
        catch (_) { status.textContent = this.dataset.copyError; }
      }, { signal });
      const enhance = () => {
        document.querySelectorAll('.mtpv2-news:not([data-mtnl-open]),[data-mtnl-upgrade]:not([data-mtnl-open])').forEach(element => {
          element.setAttribute('data-mtnl-open', ''); element.setAttribute('role', 'button'); element.setAttribute('tabindex', '0'); element.setAttribute('aria-haspopup', 'dialog'); element.setAttribute('aria-controls', this.dialog.id); element.classList.add('mtnl-trigger');
          if (!element.querySelector('.mtnl-trigger-cta')) { const label = document.createElement('span'); label.className = 'mtnl-trigger-cta'; label.textContent = this.dataset.triggerLabel + ' →'; element.append(label); }
        });
      };
      enhance();
      this.observer = new MutationObserver(records => { if (records.some(record => record.addedNodes.length)) enhance(); });
      this.observer.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('shopify:section:select', event => { if (this.dataset.designMode === 'true' && event.target.contains(this)) this.open(); }, { signal });
      document.addEventListener('shopify:section:deselect', () => { if (this.dataset.designMode === 'true' && this.dialog.open) this.dialog.close(); }, { signal });
      const ownReturn = location.hash === '#' + this.querySelector('form').id;
      this.ownError = ownReturn && !!this.querySelector('[data-mtnl-server-error]');
      this.ownSuccess = ownReturn && !this.ownError && !!this.querySelector('[data-mtnl-server-success]');
      if (this.ownSuccess) { markSubscribed(); document.dispatchEvent(new CustomEvent('mtnl:subscribed')); }
      this.updateBubble();
      if (this.ownSuccess || this.ownError) this.open();
      if (this.dataset.designMode === 'true' || this.dataset.auto !== 'true' || /configurateur|configurator|editeur|editor|atelier|preview|\/challenge(?:\/|$)/i.test(location.pathname + location.search)) return;
      document.addEventListener('visibilitychange', () => { if (!document.hidden) { if (this.dialog.open) this.updateCountdown(); else this.scheduleAuto(); } }, { signal });
      window.addEventListener('storage', event => { if ((event.key === this.key || event.key === 'mtnl_native_confirmed_v2') && event.newValue) { clearTimeout(this.timer); if (event.key === 'mtnl_native_confirmed_v2') { this.confirmed = true; this.updateBubble(); } } }, { signal });
      const ready = () => { this.readyAt = Date.now() + 6000; this.scheduleAuto(); };
      if (document.readyState !== 'loading') ready();
      else document.addEventListener('DOMContentLoaded', ready, { once: true, signal });
    }
    visibleBusy() {
      return Array.from(document.querySelectorAll('dialog[open],.mtp-open,.mt-cfg.is-open,.mtmc.is-open,.musee-config.is-open,.mt-volet.mt-open,[aria-modal="true"]:not(dialog):not([hidden])')).some(element => element !== this.dialog && element.getClientRects().length && element.getAttribute('aria-hidden') !== 'true' && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0');
    }
    scheduleAuto() {
      clearTimeout(this.timer);
      if (!this.readyAt || this.seen() || this.confirmed || !this.isConnected || this.dialog.open) return;
      this.timer = setTimeout(() => {
        if (this.seen() || this.confirmed || !this.isConnected) return;
        if (document.hidden || this.visibleBusy() || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '') || document.activeElement?.isContentEditable) { this.timer = setTimeout(() => this.scheduleAuto(), 2000); return; }
        this.open(null, true);
      }, Math.max(0, this.readyAt - Date.now()));
    }
    open(trigger, automatic = false) {
      if (!this.isConnected || this.dialog.open || document.hidden || this.visibleBusy()) return;
      if (automatic && (this.seen() || this.confirmed)) return;
      this.previousFocus = trigger || document.activeElement;
      const image = this.querySelector('.mtnl-photo img');
      if (image && !image.getAttribute('src')) { image.sizes = image.dataset.sizes; image.srcset = image.dataset.srcset; image.src = image.dataset.src; }
      this.dialog.showModal();
      document.documentElement.classList.add('mtnl-open');
      this.closeDeadline = automatic ? Date.now() + 3000 : 0;
      this.updateCountdown();
      if (this.dataset.designMode !== 'true') this.remember();
      this.showStep(this.ownError ? 'form' : this.confirmed ? 'done' : 'form');
    }
    showStep(step) {
      this.step = step;
      this.querySelectorAll('[data-mtnl-step]').forEach(panel => { panel.hidden = panel.dataset.mtnlStep !== step; });
      this.dialog.scrollTop = 0;
      const focus = step === 'done' ? this.querySelector('.mtnl-success-heading') : this.querySelector('.mtnl-title');
      focus?.focus({ preventScroll: true });
    }
    updateCountdown() {
      clearTimeout(this.closeTimer);
      const remaining = Math.max(0, (this.closeDeadline || 0) - Date.now());
      const seconds = Math.ceil(remaining / 1000);
      this.closeButton.setAttribute('aria-disabled', String(seconds > 0));
      this.closeButton.setAttribute('aria-label', seconds ? this.closeLabel + ' (' + seconds + ' s)' : this.closeLabel);
      this.countdown.hidden = !seconds; this.countdown.textContent = seconds ? String(seconds) : '';
      if (remaining) this.closeTimer = setTimeout(() => this.updateCountdown(), Math.min(250, remaining));
    }
    canClose() { this.updateCountdown(); return Date.now() >= (this.closeDeadline || 0); }
    requestClose() { if (this.canClose()) this.dialog.close(); }
    disconnectedCallback() { clearTimeout(this.timer); clearTimeout(this.closeTimer); this.controller?.abort(); this.observer?.disconnect(); if (this.dialog?.open) this.dialog.close(); document.documentElement.classList.remove('mtnl-open'); }
  }
  customElements.define('mt-newsletter-popup', MtNewsletterPopup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-welcome-intro"]) return;
  try {
    
if (!customElements.get('mt-welcome-intro')) {
  class MtWelcomeIntro extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.key = 'mt_welcome_seen_v1';
      this.seen = () => {
        try { if (localStorage.getItem(this.key)) return true; } catch (_) {}
        try { if (sessionStorage.getItem(this.key)) return true; } catch (_) {}
        try { return document.cookie.split(';').some(item => item.trim().startsWith(this.key + '=1')); } catch (_) { return false; }
      };
      this.remember = () => {
        try { localStorage.setItem(this.key, '1'); } catch (_) {}
        try { sessionStorage.setItem(this.key, '1'); } catch (_) {}
        try { document.cookie = this.key + '=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure'; } catch (_) {}
      };
      this.closeButton = this.querySelector('.mtwi-close');
      this.countdown = this.querySelector('.mtwi-countdown');
      this.closeLabel = this.closeButton.getAttribute('aria-label');
      this.closeButton.addEventListener('click', () => this.requestClose(), { signal });
      this.dialog.addEventListener('cancel', event => {
        if (!this.canClose()) event.preventDefault();
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.requestClose();
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.clearCloseCountdown();
        document.documentElement.classList.remove('mtwi-open');
        if (this.dataset.designMode !== 'true') this.remember();
        if (this.previousFocus?.isConnected && this.previousFocus !== document.body) this.previousFocus.focus({ preventScroll: true });
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && this.dialog.open) this.updateCloseCountdown();
      }, { signal });
      window.addEventListener('storage', event => { if (event.key === this.key && event.newValue) clearTimeout(this.timer); }, { signal });
      if (this.dataset.designMode === 'true') {
        document.addEventListener('shopify:section:select', event => { if (event.target.contains(this)) this.open(true); }, { signal });
        document.addEventListener('shopify:section:deselect', () => { if (this.dialog.open) this.dialog.close(); }, { signal });
        return;
      }
      if (this.seen() || /configurateur|configurator|editeur|editor|atelier|preview_theme_id/i.test(location.pathname + location.search)) return;
      this.attempts = 0;
      const schedule = () => { this.timer = setTimeout(() => this.open(false), 1800); };
      if (document.readyState === 'complete') schedule();
      else window.addEventListener('load', schedule, { once: true, signal });
    }
    open(preview) {
      if (!this.isConnected || this.dialog.open || (!preview && this.seen())) return;
      const busy = document.hidden || Array.from(document.querySelectorAll('dialog[open],.mtp-open,.mt-cfg.is-open,.mtmc.is-open,.musee-config.is-open,[aria-modal="true"]:not(dialog):not([hidden])')).some(element => element.getClientRects().length && element.getAttribute('aria-hidden') !== 'true' && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).opacity !== '0') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '');
      if (busy) {
        if (++this.attempts < 15) this.timer = setTimeout(() => this.open(preview), 2000);
        return;
      }
      const image = this.querySelector('img');
      if (!this.fontReady) {
        const font = new FontFace('MT Welcome Hand', 'url(https://fonts.gstatic.com/l/font?kit=WnznHAc5bAfYB2QRah7pcpNvOx-pjcB9SIK7STQYy2vD15BLBoVH8ERRhqphRtBe3JcJhg88hhESbOqH3SjVWrAnCqhIyGaHeA&skey=7833cd5b856b60c9&v=v23)', { weight: '500', display: 'swap' });
        this.fontReady = Promise.race([font.load().then(loaded => document.fonts.add(loaded)).catch(() => {}), new Promise(resolve => setTimeout(resolve, 1500))]);
      }
      if (!image.getAttribute('src')) {
        image.sizes = image.dataset.sizes;
        image.srcset = image.dataset.srcset;
        image.src = image.dataset.src;
      }
      const show = () => {
        if (!this.isConnected || document.hidden || (!preview && this.seen()) || document.querySelector('dialog[open]') || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName || '')) return;
        this.previousFocus = document.activeElement;
        this.startCloseCountdown();
        this.dialog.showModal();
        document.documentElement.classList.add('mtwi-open');
        if (!preview) this.remember();
      };
      const ready = () => this.fontReady.then(show);
      if (image.complete && image.naturalWidth) ready();
      else image.addEventListener('load', ready, { once: true, signal: this.controller.signal });
    }
    startCloseCountdown() {
      this.closeDeadline = Date.now() + 3000;
      this.updateCloseCountdown();
    }
    updateCloseCountdown() {
      clearTimeout(this.closeTimer);
      const remaining = Math.max(0, (this.closeDeadline || 0) - Date.now());
      const seconds = Math.ceil(remaining / 1000);
      this.closeButton.setAttribute('aria-disabled', String(seconds > 0));
      this.closeButton.setAttribute('aria-label', seconds ? this.closeLabel + ' (' + seconds + ' s)' : this.closeLabel);
      this.countdown.hidden = !seconds;
      this.countdown.textContent = seconds ? String(seconds) : '';
      if (remaining) this.closeTimer = setTimeout(() => this.updateCloseCountdown(), Math.min(250, remaining));
    }
    canClose() {
      this.updateCloseCountdown();
      return Date.now() >= (this.closeDeadline || 0);
    }
    requestClose() {
      if (this.canClose()) this.dialog.close();
    }
    clearCloseCountdown() {
      this.closeDeadline = 0;
      this.updateCloseCountdown();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      clearTimeout(this.closeTimer);
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      document.documentElement.classList.remove('mtwi-open');
    }
  }
  customElements.define('mt-welcome-intro', MtWelcomeIntro);
}

  } catch(e) { console.error(e); }
})();
})();
